<template>
  <!-- 會員身份標識：Pro 會員（P）、Group 成員（G），數據來自 admin 接口的 user_tags 欄位 -->
  <span class="user-tags" v-if="showTags.length">
    <span
      v-for="tag in showTags"
      :key="tag.key"
      :class="['tag-badge', tag.className]"
      :title="tag.label">{{ tag.text }}</span>
  </span>
</template>

<script>
const TAG_META = {
  pro: { text: 'P', label: 'Pro 會員', className: 'tag-badge--pro' },
  group: { text: 'G', label: 'Group 成員（碳標籤團隊）', className: 'tag-badge--group' }
}

export default {
  name: 'UserTags',
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showTags () {
      return (this.tags || [])
        .filter(tag => TAG_META[tag])
        .map(tag => Object.assign({ key: tag }, TAG_META[tag]))
    }
  }
}
</script>

<style scoped>
.user-tags {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  vertical-align: middle;
}
.tag-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  cursor: default;
  user-select: none;
}
.tag-badge + .tag-badge {
  margin-left: 2px;
}
/* 主題色：黃 @color-theme-yellow #f5be13、藍 @color-theme-blue #315495 */
.tag-badge--pro {
  background: linear-gradient(135deg, #f7cf4a 0%, #f5be13 100%);
  box-shadow: 0 1px 2px rgba(245, 190, 19, 0.4);
}
.tag-badge--group {
  background: linear-gradient(135deg, #4a6db3 0%, #315495 100%);
  box-shadow: 0 1px 2px rgba(49, 84, 149, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/UserTags.vue